import type { GridRowSelectionModel } from '@mui/x-data-grid';

export const formatDateTime = (value: string | null | undefined): string => {
  if (!value) {
    return '—';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleString();
};

export const clampQuantity = (value: number, max: number): number => {
  if (!Number.isFinite(value)) {
    return 0;
  }

  return Math.max(0, Math.min(max, Math.floor(value)));
};

export const hasSelection = (selection: GridRowSelectionModel, id: string): boolean => {
  return selection.some((value) => String(value) === id);
};
